import { render, staticRenderFns } from "./hometal.vue?vue&type=template&id=2583b4ac&scoped=true"
import script from "./hometal.vue?vue&type=script&lang=js"
export * from "./hometal.vue?vue&type=script&lang=js"
import style0 from "./hometal.vue?vue&type=style&index=0&id=2583b4ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2583b4ac",
  null
  
)

export default component.exports